export const MessageIcon = ({ color = 'var(--gray-700)', size = '16' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.33333 6.33333H4.34M7 6.33333H7.00667M9.66667 6.33333H9.67333M13 6.33333C13 9.27885 10.3137 11.6667 7 11.6667C5.97382 11.6667 5.00781 11.4377 4.16311 11.034L1 11.6667L1.92999 9.18669C1.34104 8.36156 1 7.38285 1 6.33333C1 3.38781 3.68629 1 7 1C10.3137 1 13 3.38781 13 6.33333Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
